import React, { useState } from 'react';
   import { authAPI } from '../services/api';
   import './Login.css';

   function Login({ onLoginSuccess }) {
     const [isLogin, setIsLogin] = useState(true);
     const [formData, setFormData] = useState({
       name: '',
       email: '',
       password: '',
       password_confirmation: '',
     });
     const [error, setError] = useState('');
     const [loading, setLoading] = useState(false);

     const handleSubmit = async (e) => {
       e.preventDefault();
       setError('');
       setLoading(true);

       try {
         const response = isLogin
           ? await authAPI.login({ email: formData.email, password: formData.password })
           : await authAPI.register(formData);

         localStorage.setItem('auth_token', response.data.token);
         localStorage.setItem('user', JSON.stringify(response.data.user));
         onLoginSuccess(response.data.user);
       } catch (err) {
         setError(err.response?.data?.message || 'Authentication failed');
       } finally {
         setLoading(false);
       }
     };

     return (
       <div className="login-container">
         <div className="login-card">
           <h1>ContentVertex</h1>
           <h2>{isLogin ? 'Login' : 'Sign Up'}</h2>

           {error && <div className="error-message">{error}</div>}

           <form onSubmit={handleSubmit}>
             {!isLogin && (
               <input
                 type="text"
                 placeholder="Full Name"
                 className="form-input"
                 value={formData.name}
                 onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                 required
               />
             )}

             <input
               type="email"
               placeholder="Email"
               className="form-input"
               value={formData.email}
               onChange={(e) => setFormData({ ...formData, email: e.target.value })}
               required
             />

             <input
               type="password"
               placeholder="Password"
               className="form-input"
               value={formData.password}
               onChange={(e) => setFormData({ ...formData, password: e.target.value })}
               required
             />

             {!isLogin && (
               <input
                 type="password"
                 placeholder="Confirm Password"
                 className="form-input"
                 value={formData.password_confirmation}
                 onChange={(e) => setFormData({ ...formData, password_confirmation: e.target.value })}
                 required
               />
             )}

             <button type="submit" className="btn btn-primary" disabled={loading}>
               {loading ? 'Please wait...' : (isLogin ? 'Login' : 'Sign Up')}
             </button>
           </form>

           <p className="toggle-text">
             {isLogin ? "Don't have an account? " : "Already have an account? "}
             <span onClick={() => setIsLogin(!isLogin)} className="toggle-link">
               {isLogin ? 'Sign Up' : 'Login'}
             </span>
           </p>
         </div>
       </div>
     );
   }

   export default Login;
